//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MessageBox from '@/components/messageBox';

const initForm = {
  name: '',
  code: '',
  parentCode: '',
  user: [],
  description: '',
};
export default {
  name: 'EmployeeorgEdit',
  components: { MessageBox },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: [Number, String],
      default: '',
    },
    appid: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      form: initForm,
      list: [],
      userList: [],
      parentList: [],
      rules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        code: [
          {
            required: true,
            message: '请输入code',
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    title() {
      return this.rowId ? '编辑员工组织' : '新增员工组织';
    },
  },
  watch: {
    visible(n) {
      if (n) {
        this.getOrgList();
        this.searchUser();
        if (this.rowId) {
          this.$request({
            url: this.$api.getOrganizationInfo,
            data: { id: this.rowId },
          }).then((res) => {
            this.form = {
              name: res.name,
              code: res.code,
              parentCode: res.parent_code,
              user: res.user_list.map((i) => {
                return {
                  label: i.name,
                  value: i.account,
                };
              }),
              description: res.description,
            };
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            });
          });
        } else {
          this.form = { ...initForm };
          this.$nextTick(() => {
            this.$refs.form.clearValidate();
          });
        }
      }
    },
  },
  methods: {
    close() {
      this.$refs.messageBox.show({
        title: '放弃编辑后，本次编辑内容将会丢失，确认放弃？',
        titleIconType: 'warning',
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: () => {
          this.$refs.messageBox.close();
          this.$emit('close');
        },
      });
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        console.log('meowf', this.form);
        let request;
        if (this.rowId) {
          request = this.$request({
            url: this.$api.updateOrganizationInfo,
            data: {
              name: this.form.name,
              parent_code: this.form.parentCode,
              description: this.form.description,
              user_accounts: this.form.user.map((i) => i.value),
              id: this.rowId,
            },
          });
        } else {
          request = this.$request({
            url: this.$api.addOrganizationInfo,
            data: {
              name: this.form.name,
              code: this.form.code,
              parent_code: this.form.parentCode,
              description: this.form.description,
              user_accounts: this.form.user.map((i) => i.value),
              appid: this.appid,
            },
          });
        }
        request.then(() => {
          this.$message.success(this.rowId ? '编辑成功' : '新增成功');
          this.$emit('success');
        });
      });
    },
    searchUser(keyword = '') {
      const url = this.$api.getUserList;
      const data = {
        keyword,
        page: 1,
        type: 1,
        page_size: 10,
      };

      this.$request({ url, data }).then((data) => {
        this.userList = data.data.map((i) => {
          return {
            value: i.account,
            label: i.name,
          };
        });
      });
    },
    getOrgList() {
      const url = this.$api.getOrganizationList;
      const data = {
        appid: this.appid,
        page: 1,
        page_size: 999999,
      };

      this.$request({ url, data }).then((data) => {
        this.parentList = data.data;
      });
    },
  },
};
